import { GET_CONTACTS } from '../constants/contact';
import { SHOW_LOADING, HIDE_LOADING } from '../constants/commons';

const initialState = {
    loading: false,
    contacts: [],
}

export const contactReducer = (state = initialState, {type, payload}) => {
    switch (type) {
        case GET_CONTACTS:
            return {...state, contacts: payload};
        case SHOW_LOADING:
            return {...state, loading: true};
        case HIDE_LOADING:
            return {...state, loading: false};
        default:
            return state;
    }
} 